import React from "react";
import HyroLoader from "@hyro-components/HyroLoader";
import { getLiveAccessToken, isTokenValid } from "src/services/tokenRefresh";
import GenericErrorPage from "./GenericErrorPage";

// A persistent 401 with a dead token means the response interceptor is redirecting to
// login — hold the loader while the navigation happens. A 401 with a live token never
// redirects, so it must surface as an error instead of an endless spinner.
const UnauthorizedErrorPage = () =>
  (isTokenValid(getLiveAccessToken()) ? <GenericErrorPage /> : <HyroLoader height="100vh" />);

export default UnauthorizedErrorPage;
